import { useCallback } from "react";
import useAddItem from "@vercel/commerce/wishlist/use-add-item";
import useWishlist from "./use-wishlist";
import ensureIToken from "../utils/tokens/ensure-itoken";
import isLoggedIn from "../utils/tokens/is-logged-in";
import normalizeWishlist from "../utils/normalizations/normalize-wishlist";
import { requireConfigValue } from "../isomorphic-config";
const defaultImagesSize = requireConfigValue("imagesSize");
const defaultImagesQuality = requireConfigValue("imagesQuality");
export default useAddItem;
export const handler = {
    fetchOptions: {
        url: "wishlists",
        query: "addWishedItem"
    },
    async fetcher ({ input , options , fetch  }) {
        //Uncomment the following line to debug
        /*   console.info(
      'useAddItem (wishlist) fetcher called. Configuration: ',
      'input: ',
      input,
      'options: ',
      options
    ) */ const { item: { productId , variantId , diamondId , wishlistToken  } ,  } = input;
        if (!isLoggedIn() && !wishlistToken) {
            return null;
        }
        let token = ensureIToken();
        let addItemParameters = null;
        if (variantId && diamondId) {
            addItemParameters = {
                variant_id: `${variantId}`,
                diamond_id: `${diamondId}`
            };
        } else if (variantId) {
            addItemParameters = {
                variant_id: `${variantId}`
            };
        } else if (diamondId) {
            addItemParameters = {
                diamond_id: `${diamondId}`
            };
        } else {
            return null;
        }
        addItemParameters = {
            ...addItemParameters,
            include: [
                "wished_items",
                "wished_items.variant",
                "wished_items.variant.product",
                "wished_items.variant.product.primary_variant",
                "wished_items.variant.product.images",
                "wished_items.variant.product.option_types",
                "wished_items.variant.product.variants",
                "wished_items.variant.product.variants.option_values",
                "wished_items.diamond", 
            ].join(","),
            image_transformation: {
                quality: defaultImagesQuality,
                size: "600x600" || defaultImagesSize
            }
        };
        const { data: spreeWishlistSuccessResponse  } = await fetch({
            variables: {
                methodPath: "wishlists.addWishedItem",
                arguments: [
                    token,
                    wishlistToken,
                    addItemParameters
                ]
            }
        });
        if (spreeWishlistSuccessResponse) {
            const normalizedWishlist = normalizeWishlist(spreeWishlistSuccessResponse, spreeWishlistSuccessResponse.data);
            return normalizedWishlist;
        } else {
            return null;
        }
    },
    useHook: ({ fetch  })=>{
        const useWrappedHook = ()=>{
            const wishlist = useWishlist();
            return useCallback(async (item)=>{
                if (!wishlist.data) {
                    return null;
                }
                const data = await fetch({
                    input: {
                        item: {
                            ...item,
                            wishlistToken: wishlist.data.token
                        }
                    }
                });
                await wishlist.mutate(data, false);
                return data;
            }, [
                wishlist
            ]);
        };
        return useWrappedHook;
    }
};
